
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/dashboard",
      function () {
        return require("private-next-pages/qmee/dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/dashboard"])
      });
    }
  